import { createSlice } from '@reduxjs/toolkit';

/**
 * @typedef {object} StatsGlossaryState
 * @property {object} glossary
 */

/**
 * @type {StatsGlossaryState}
 */
const initialState = {
    terms: {},
    modalVisible: false
};

export const glossarySlice = createSlice({
    name: `statspro/glossary`,
    initialState,
    reducers: {
        setGlossaryTerms: (state, action) => {
            state.terms = action.payload;
        },
        setGlossaryModalVisibility: (state, action) => {
            state.modalVisible = action.payload;
        }
    }
});

export const glossaryReducer = glossarySlice.reducer;
export const glossaryActions = glossarySlice.actions;
